"use client";
import React from "react";
import Image from "next/image";

import { getProfileImage } from "@lib/helpers";
import { IEmployer } from "@globalTypes";
import { cn } from "@lib/utils";

interface CompanyLogoProps {
  employer?: IEmployer | null;
  className?: string;
}

const CompanyLogo = ({ employer, className }: CompanyLogoProps) => {
  return (
    <div>
      {employer?.employer_profile?.companyLogo ? (
        <Image
          width={112}
          height={112}
          className={cn(
            "w-20 sm:w-28 h-20 sm:h-28 rounded-[8px] object-cover sm:mx-auto",
            className
          )}
          alt={employer?.employer_profile?.companyName || ""}
          src={getProfileImage({
            image: employer?.employer_profile?.companyLogo || "",
            name: employer?.employer_profile?.companyName || "",
            id: employer?.employer_profile?.userId || "",
          })}
        />
      ) : (
        <div
          className={cn(
            "bg-[#B9BDC2] w-20 sm:w-28 h-20 sm:h-28 sm:mx-auto flex flex-row items-center justify-center rounded-[8px] object-cover text-white text-[36px] sm:text-[56px] font-bold",
            className
          )}
        >
          <h3 className="font-normal">
            {employer?.employer_profile?.companyName
              ?.charAt(0)
              ?.toUpperCase() || ""}
          </h3>
        </div>
      )}
    </div>
  );
};

export default CompanyLogo;
